// eslint-disable-next-line import/prefer-default-export
export const setTheme = {
  beforeMount() {
    const theme = this.$store.getters['bookingChannel/theme'];
    if (theme) {
      this.$vuetify.theme.themes.light.primary = theme.primary;
      this.$vuetify.theme.themes.dark.primary = theme.primary;
      this.$vuetify.theme.themes.light.primaryFont = theme.primaryFont;
      this.$vuetify.theme.themes.dark.primaryFont = theme.primaryFont;
    }
  },
};
